/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var authenticate_pb = require('./authenticate_pb.js');
goog.object.extend(proto, authenticate_pb);
var fileupload_pb = require('./fileupload_pb.js');
goog.object.extend(proto, fileupload_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.apibuffers.ExternalImage', null, global);
goog.exportSymbol('proto.apibuffers.FollowType', null, global);
goog.exportSymbol('proto.apibuffers.FollowingStatus', null, global);
goog.exportSymbol('proto.apibuffers.Gender', null, global);
goog.exportSymbol('proto.apibuffers.GeoFence', null, global);
goog.exportSymbol('proto.apibuffers.GeoFenceEventType', null, global);
goog.exportSymbol('proto.apibuffers.Group', null, global);
goog.exportSymbol('proto.apibuffers.Interest', null, global);
goog.exportSymbol('proto.apibuffers.LegalRequirements', null, global);
goog.exportSymbol('proto.apibuffers.SessionRequest', null, global);
goog.exportSymbol('proto.apibuffers.SessionRequest.SessionRequestType', null, global);
goog.exportSymbol('proto.apibuffers.SexualPreference', null, global);
goog.exportSymbol('proto.apibuffers.User', null, global);
goog.exportSymbol('proto.apibuffers.UserBatchFollowRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserBatchFollowResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserExternalSystem', null, global);
goog.exportSymbol('proto.apibuffers.UserFollowRelationship', null, global);
goog.exportSymbol('proto.apibuffers.UserFollowRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserFollowsResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserFollowsResponse.UserFollowStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadExternalImagesRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadExternalImagesRequest.ImageType', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadFacebookFriendsResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadMeRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadMeResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadUserRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserLoadUserResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserMedia', null, global);
goog.exportSymbol('proto.apibuffers.UserMedia.UserMediaType', null, global);
goog.exportSymbol('proto.apibuffers.UserPrivacySettings', null, global);
goog.exportSymbol('proto.apibuffers.UserPrivacySettings.PrivacyType', null, global);
goog.exportSymbol('proto.apibuffers.UserSearchRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserSearchResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserSetInviteRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserSetInviteResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateInterestsRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateInterestsRequest.Action', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateLocationRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateLocationRequest.UpdateType', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateLocationResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserUpdateResponse.UpdateUserStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateResponse.UserValidateResponseStatus', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateSendCodeRequest', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateSendCodeResponse', null, global);
goog.exportSymbol('proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Interest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Interest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Interest.displayName = 'proto.apibuffers.Interest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.Group = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.Group, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.Group.displayName = 'proto.apibuffers.Group';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserMedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserMedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserMedia.displayName = 'proto.apibuffers.UserMedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.User.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.User.displayName = 'proto.apibuffers.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadMeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserLoadMeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadMeRequest.displayName = 'proto.apibuffers.UserLoadMeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserExternalSystem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserExternalSystem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserExternalSystem.displayName = 'proto.apibuffers.UserExternalSystem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadMeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserLoadMeResponse.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserLoadMeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadMeResponse.displayName = 'proto.apibuffers.UserLoadMeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserSearchRequest.displayName = 'proto.apibuffers.UserSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserSearchResponse.displayName = 'proto.apibuffers.UserSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserLoadUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadUserRequest.displayName = 'proto.apibuffers.UserLoadUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserPrivacySettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserPrivacySettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserPrivacySettings.displayName = 'proto.apibuffers.UserPrivacySettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserLoadUserResponse.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserLoadUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadUserResponse.displayName = 'proto.apibuffers.UserLoadUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadExternalImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserLoadExternalImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadExternalImagesRequest.displayName = 'proto.apibuffers.UserLoadExternalImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.ExternalImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.ExternalImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.ExternalImage.displayName = 'proto.apibuffers.ExternalImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserLoadFacebookFriendsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserLoadFacebookFriendsResponse.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserLoadFacebookFriendsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserLoadFacebookFriendsResponse.displayName = 'proto.apibuffers.UserLoadFacebookFriendsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserUpdateRequest.displayName = 'proto.apibuffers.UserUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserUpdateResponse.displayName = 'proto.apibuffers.UserUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserUpdateLocationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserUpdateLocationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserUpdateLocationRequest.displayName = 'proto.apibuffers.UserUpdateLocationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.GeoFence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.GeoFence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.GeoFence.displayName = 'proto.apibuffers.GeoFence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserUpdateLocationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserUpdateLocationResponse.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserUpdateLocationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserUpdateLocationResponse.displayName = 'proto.apibuffers.UserUpdateLocationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserUpdateInterestsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserUpdateInterestsRequest.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserUpdateInterestsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserUpdateInterestsRequest.displayName = 'proto.apibuffers.UserUpdateInterestsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserValidateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserValidateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserValidateRequest.displayName = 'proto.apibuffers.UserValidateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserValidateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserValidateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserValidateResponse.displayName = 'proto.apibuffers.UserValidateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserValidateSendCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserValidateSendCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserValidateSendCodeRequest.displayName = 'proto.apibuffers.UserValidateSendCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserValidateSendCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserValidateSendCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserValidateSendCodeResponse.displayName = 'proto.apibuffers.UserValidateSendCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserSetInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserSetInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserSetInviteRequest.displayName = 'proto.apibuffers.UserSetInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserSetInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserSetInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserSetInviteResponse.displayName = 'proto.apibuffers.UserSetInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserFollowRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserFollowRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserFollowRequest.displayName = 'proto.apibuffers.UserFollowRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserFollowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserFollowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserFollowsResponse.displayName = 'proto.apibuffers.UserFollowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserBatchFollowRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.apibuffers.UserBatchFollowRequest.repeatedFields_, null);
};
goog.inherits(proto.apibuffers.UserBatchFollowRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserBatchFollowRequest.displayName = 'proto.apibuffers.UserBatchFollowRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserBatchFollowResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserBatchFollowResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserBatchFollowResponse.displayName = 'proto.apibuffers.UserBatchFollowResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.UserFollowRelationship = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.UserFollowRelationship, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.UserFollowRelationship.displayName = 'proto.apibuffers.UserFollowRelationship';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.apibuffers.SessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.apibuffers.SessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.apibuffers.SessionRequest.displayName = 'proto.apibuffers.SessionRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Interest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Interest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Interest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Interest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    image: (f = msg.getImage()) && common_pb.Image.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Interest}
 */
proto.apibuffers.Interest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Interest;
  return proto.apibuffers.Interest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Interest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Interest}
 */
proto.apibuffers.Interest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new common_pb.Image;
      reader.readMessage(value,common_pb.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Interest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Interest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Interest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Interest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Image.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.apibuffers.Interest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Interest.prototype.setCode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.apibuffers.Interest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.Interest.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Image image = 3;
 * @return {?proto.apibuffers.Image}
 */
proto.apibuffers.Interest.prototype.getImage = function() {
  return /** @type{?proto.apibuffers.Image} */ (
    jspb.Message.getWrapperField(this, common_pb.Image, 3));
};


/** @param {?proto.apibuffers.Image|undefined} value */
proto.apibuffers.Interest.prototype.setImage = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.Interest.prototype.clearImage = function() {
  this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.Interest.prototype.hasImage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.Group.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.Group.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.Group} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Group.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.Group}
 */
proto.apibuffers.Group.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.Group;
  return proto.apibuffers.Group.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.Group} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.Group}
 */
proto.apibuffers.Group.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.Group.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.Group.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.Group} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.Group.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.Group.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.Group.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.apibuffers.Group.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.Group.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserMedia.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserMedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserMedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserMedia.toObject = function(includeInstance, msg) {
  var f, obj = {
    mediaType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    image: (f = msg.getImage()) && common_pb.Image.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserMedia}
 */
proto.apibuffers.UserMedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserMedia;
  return proto.apibuffers.UserMedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserMedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserMedia}
 */
proto.apibuffers.UserMedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserMedia.UserMediaType} */ (reader.readEnum());
      msg.setMediaType(value);
      break;
    case 2:
      var value = new common_pb.Image;
      reader.readMessage(value,common_pb.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserMedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserMedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserMedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserMedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMediaType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Image.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserMedia.UserMediaType = {
  PROFILE_IMAGE: 0,
  COVER_IMAGE: 1,
  MAP_IMAGE: 2
};

/**
 * optional UserMediaType media_type = 1;
 * @return {!proto.apibuffers.UserMedia.UserMediaType}
 */
proto.apibuffers.UserMedia.prototype.getMediaType = function() {
  return /** @type {!proto.apibuffers.UserMedia.UserMediaType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserMedia.UserMediaType} value */
proto.apibuffers.UserMedia.prototype.setMediaType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Image image = 2;
 * @return {?proto.apibuffers.Image}
 */
proto.apibuffers.UserMedia.prototype.getImage = function() {
  return /** @type{?proto.apibuffers.Image} */ (
    jspb.Message.getWrapperField(this, common_pb.Image, 2));
};


/** @param {?proto.apibuffers.Image|undefined} value */
proto.apibuffers.UserMedia.prototype.setImage = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserMedia.prototype.clearImage = function() {
  this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserMedia.prototype.hasImage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.User.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.User.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dateOfBirth: (f = msg.getDateOfBirth()) && common_pb.Date.toObject(includeInstance, f),
    bio: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mediaList: jspb.Message.toObjectList(msg.getMediaList(),
    proto.apibuffers.UserMedia.toObject, includeInstance),
    nationality: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sexualPreference: jspb.Message.getFieldWithDefault(msg, 8, 0),
    version: jspb.Message.getFieldWithDefault(msg, 9, 0),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    locationText: jspb.Message.getFieldWithDefault(msg, 11, ""),
    statusId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    referrerId: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.User}
 */
proto.apibuffers.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.User;
  return proto.apibuffers.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.User}
 */
proto.apibuffers.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {!proto.apibuffers.Gender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 4:
      var value = new common_pb.Date;
      reader.readMessage(value,common_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfBirth(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBio(value);
      break;
    case 6:
      var value = new proto.apibuffers.UserMedia;
      reader.readMessage(value,proto.apibuffers.UserMedia.deserializeBinaryFromReader);
      msg.addMedia(value);
      break;
    case 7:
      var value = /** @type {!proto.apibuffers.CountryCode} */ (reader.readEnum());
      msg.setNationality(value);
      break;
    case 8:
      var value = /** @type {!proto.apibuffers.SexualPreference} */ (reader.readEnum());
      msg.setSexualPreference(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVersion(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationText(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDateOfBirth();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getBio();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMediaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.apibuffers.UserMedia.serializeBinaryToWriter
    );
  }
  f = message.getNationality();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSexualPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getLocationText();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatusId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getReferrerId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.apibuffers.User.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Gender gender = 3;
 * @return {!proto.apibuffers.Gender}
 */
proto.apibuffers.User.prototype.getGender = function() {
  return /** @type {!proto.apibuffers.Gender} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.apibuffers.Gender} value */
proto.apibuffers.User.prototype.setGender = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Date date_of_birth = 4;
 * @return {?proto.apibuffers.Date}
 */
proto.apibuffers.User.prototype.getDateOfBirth = function() {
  return /** @type{?proto.apibuffers.Date} */ (
    jspb.Message.getWrapperField(this, common_pb.Date, 4));
};


/** @param {?proto.apibuffers.Date|undefined} value */
proto.apibuffers.User.prototype.setDateOfBirth = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.User.prototype.clearDateOfBirth = function() {
  this.setDateOfBirth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.User.prototype.hasDateOfBirth = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string bio = 5;
 * @return {string}
 */
proto.apibuffers.User.prototype.getBio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setBio = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated UserMedia media = 6;
 * @return {!Array<!proto.apibuffers.UserMedia>}
 */
proto.apibuffers.User.prototype.getMediaList = function() {
  return /** @type{!Array<!proto.apibuffers.UserMedia>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.UserMedia, 6));
};


/** @param {!Array<!proto.apibuffers.UserMedia>} value */
proto.apibuffers.User.prototype.setMediaList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.apibuffers.UserMedia=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.UserMedia}
 */
proto.apibuffers.User.prototype.addMedia = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.apibuffers.UserMedia, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.User.prototype.clearMediaList = function() {
  this.setMediaList([]);
};


/**
 * optional CountryCode nationality = 7;
 * @return {!proto.apibuffers.CountryCode}
 */
proto.apibuffers.User.prototype.getNationality = function() {
  return /** @type {!proto.apibuffers.CountryCode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.apibuffers.CountryCode} value */
proto.apibuffers.User.prototype.setNationality = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional SexualPreference sexual_preference = 8;
 * @return {!proto.apibuffers.SexualPreference}
 */
proto.apibuffers.User.prototype.getSexualPreference = function() {
  return /** @type {!proto.apibuffers.SexualPreference} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {!proto.apibuffers.SexualPreference} value */
proto.apibuffers.User.prototype.setSexualPreference = function(value) {
  jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int64 version = 9;
 * @return {number}
 */
proto.apibuffers.User.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.apibuffers.User.prototype.setVersion = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool verified = 10;
 * @return {boolean}
 */
proto.apibuffers.User.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.apibuffers.User.prototype.setVerified = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string location_text = 11;
 * @return {string}
 */
proto.apibuffers.User.prototype.getLocationText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setLocationText = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string status_id = 12;
 * @return {string}
 */
proto.apibuffers.User.prototype.getStatusId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setStatusId = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string referrer_id = 13;
 * @return {string}
 */
proto.apibuffers.User.prototype.getReferrerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.apibuffers.User.prototype.setReferrerId = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadMeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadMeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadMeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadMeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadMeRequest}
 */
proto.apibuffers.UserLoadMeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadMeRequest;
  return proto.apibuffers.UserLoadMeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadMeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadMeRequest}
 */
proto.apibuffers.UserLoadMeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadMeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadMeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadMeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadMeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserExternalSystem.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserExternalSystem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserExternalSystem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserExternalSystem.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserExternalSystem}
 */
proto.apibuffers.UserExternalSystem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserExternalSystem;
  return proto.apibuffers.UserExternalSystem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserExternalSystem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserExternalSystem}
 */
proto.apibuffers.UserExternalSystem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.AuthSystemType} */ (reader.readEnum());
      msg.setSystemType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserExternalSystem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserExternalSystem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserExternalSystem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserExternalSystem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional AuthSystemType system_type = 1;
 * @return {!proto.apibuffers.AuthSystemType}
 */
proto.apibuffers.UserExternalSystem.prototype.getSystemType = function() {
  return /** @type {!proto.apibuffers.AuthSystemType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.AuthSystemType} value */
proto.apibuffers.UserExternalSystem.prototype.setSystemType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserLoadMeResponse.repeatedFields_ = [4,6,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadMeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadMeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadMeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadMeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    me: (f = msg.getMe()) && proto.apibuffers.User.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currentLocation: (f = msg.getCurrentLocation()) && common_pb.Location.toObject(includeInstance, f),
    interestsList: jspb.Message.toObjectList(msg.getInterestsList(),
    proto.apibuffers.Interest.toObject, includeInstance),
    userStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    externalSystemsList: jspb.Message.toObjectList(msg.getExternalSystemsList(),
    proto.apibuffers.UserExternalSystem.toObject, includeInstance),
    shareUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    legalRequirementsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    privacySettings: (f = msg.getPrivacySettings()) && proto.apibuffers.UserPrivacySettings.toObject(includeInstance, f),
    preferredCurrency: jspb.Message.getFieldWithDefault(msg, 11, ""),
    validated: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    inviteCode: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadMeResponse}
 */
proto.apibuffers.UserLoadMeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadMeResponse;
  return proto.apibuffers.UserLoadMeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadMeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadMeResponse}
 */
proto.apibuffers.UserLoadMeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.apibuffers.User;
      reader.readMessage(value,proto.apibuffers.User.deserializeBinaryFromReader);
      msg.setMe(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = new common_pb.Location;
      reader.readMessage(value,common_pb.Location.deserializeBinaryFromReader);
      msg.setCurrentLocation(value);
      break;
    case 4:
      var value = new proto.apibuffers.Interest;
      reader.readMessage(value,proto.apibuffers.Interest.deserializeBinaryFromReader);
      msg.addInterests(value);
      break;
    case 5:
      var value = /** @type {!proto.apibuffers.UserStatus} */ (reader.readEnum());
      msg.setUserStatus(value);
      break;
    case 6:
      var value = new proto.apibuffers.UserExternalSystem;
      reader.readMessage(value,proto.apibuffers.UserExternalSystem.deserializeBinaryFromReader);
      msg.addExternalSystems(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareUrl(value);
      break;
    case 9:
      var value = /** @type {!Array<!proto.apibuffers.LegalRequirements>} */ (reader.readPackedEnum());
      msg.setLegalRequirementsList(value);
      break;
    case 10:
      var value = new proto.apibuffers.UserPrivacySettings;
      reader.readMessage(value,proto.apibuffers.UserPrivacySettings.deserializeBinaryFromReader);
      msg.setPrivacySettings(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredCurrency(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidated(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadMeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadMeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadMeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadMeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMe();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.apibuffers.User.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrentLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Location.serializeBinaryToWriter
    );
  }
  f = message.getInterestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.apibuffers.Interest.serializeBinaryToWriter
    );
  }
  f = message.getUserStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getExternalSystemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.apibuffers.UserExternalSystem.serializeBinaryToWriter
    );
  }
  f = message.getShareUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLegalRequirementsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      9,
      f
    );
  }
  f = message.getPrivacySettings();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.apibuffers.UserPrivacySettings.serializeBinaryToWriter
    );
  }
  f = message.getPreferredCurrency();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getValidated();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional User me = 1;
 * @return {?proto.apibuffers.User}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getMe = function() {
  return /** @type{?proto.apibuffers.User} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.User, 1));
};


/** @param {?proto.apibuffers.User|undefined} value */
proto.apibuffers.UserLoadMeResponse.prototype.setMe = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearMe = function() {
  this.setMe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserLoadMeResponse.prototype.hasMe = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadMeResponse.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Location current_location = 3;
 * @return {?proto.apibuffers.Location}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getCurrentLocation = function() {
  return /** @type{?proto.apibuffers.Location} */ (
    jspb.Message.getWrapperField(this, common_pb.Location, 3));
};


/** @param {?proto.apibuffers.Location|undefined} value */
proto.apibuffers.UserLoadMeResponse.prototype.setCurrentLocation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearCurrentLocation = function() {
  this.setCurrentLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserLoadMeResponse.prototype.hasCurrentLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Interest interests = 4;
 * @return {!Array<!proto.apibuffers.Interest>}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getInterestsList = function() {
  return /** @type{!Array<!proto.apibuffers.Interest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.Interest, 4));
};


/** @param {!Array<!proto.apibuffers.Interest>} value */
proto.apibuffers.UserLoadMeResponse.prototype.setInterestsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.apibuffers.Interest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.Interest}
 */
proto.apibuffers.UserLoadMeResponse.prototype.addInterests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.apibuffers.Interest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearInterestsList = function() {
  this.setInterestsList([]);
};


/**
 * optional UserStatus user_status = 5;
 * @return {!proto.apibuffers.UserStatus}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getUserStatus = function() {
  return /** @type {!proto.apibuffers.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.apibuffers.UserStatus} value */
proto.apibuffers.UserLoadMeResponse.prototype.setUserStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated UserExternalSystem external_systems = 6;
 * @return {!Array<!proto.apibuffers.UserExternalSystem>}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getExternalSystemsList = function() {
  return /** @type{!Array<!proto.apibuffers.UserExternalSystem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.UserExternalSystem, 6));
};


/** @param {!Array<!proto.apibuffers.UserExternalSystem>} value */
proto.apibuffers.UserLoadMeResponse.prototype.setExternalSystemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.apibuffers.UserExternalSystem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.UserExternalSystem}
 */
proto.apibuffers.UserLoadMeResponse.prototype.addExternalSystems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.apibuffers.UserExternalSystem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearExternalSystemsList = function() {
  this.setExternalSystemsList([]);
};


/**
 * optional string share_url = 8;
 * @return {string}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getShareUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadMeResponse.prototype.setShareUrl = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated LegalRequirements legal_requirements = 9;
 * @return {!Array<!proto.apibuffers.LegalRequirements>}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getLegalRequirementsList = function() {
  return /** @type {!Array<!proto.apibuffers.LegalRequirements>} */ (jspb.Message.getRepeatedField(this, 9));
};


/** @param {!Array<!proto.apibuffers.LegalRequirements>} value */
proto.apibuffers.UserLoadMeResponse.prototype.setLegalRequirementsList = function(value) {
  jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!proto.apibuffers.LegalRequirements} value
 * @param {number=} opt_index
 */
proto.apibuffers.UserLoadMeResponse.prototype.addLegalRequirements = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearLegalRequirementsList = function() {
  this.setLegalRequirementsList([]);
};


/**
 * optional UserPrivacySettings privacy_settings = 10;
 * @return {?proto.apibuffers.UserPrivacySettings}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getPrivacySettings = function() {
  return /** @type{?proto.apibuffers.UserPrivacySettings} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.UserPrivacySettings, 10));
};


/** @param {?proto.apibuffers.UserPrivacySettings|undefined} value */
proto.apibuffers.UserLoadMeResponse.prototype.setPrivacySettings = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserLoadMeResponse.prototype.clearPrivacySettings = function() {
  this.setPrivacySettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserLoadMeResponse.prototype.hasPrivacySettings = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string preferred_currency = 11;
 * @return {string}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getPreferredCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadMeResponse.prototype.setPreferredCurrency = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool validated = 12;
 * @return {boolean}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getValidated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/** @param {boolean} value */
proto.apibuffers.UserLoadMeResponse.prototype.setValidated = function(value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string invite_code = 13;
 * @return {string}
 */
proto.apibuffers.UserLoadMeResponse.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadMeResponse.prototype.setInviteCode = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchradius: (f = msg.getSearchradius()) && common_pb.LocationCircle.toObject(includeInstance, f),
    location: (f = msg.getLocation()) && common_pb.LocationUpdate.toObject(includeInstance, f),
    userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 4, 0),
    nationality: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserSearchRequest}
 */
proto.apibuffers.UserSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserSearchRequest;
  return proto.apibuffers.UserSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserSearchRequest}
 */
proto.apibuffers.UserSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.LocationCircle;
      reader.readMessage(value,common_pb.LocationCircle.deserializeBinaryFromReader);
      msg.setSearchradius(value);
      break;
    case 2:
      var value = new common_pb.LocationUpdate;
      reader.readMessage(value,common_pb.LocationUpdate.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {!proto.apibuffers.Gender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 5:
      var value = /** @type {!proto.apibuffers.CountryCode} */ (reader.readEnum());
      msg.setNationality(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchradius();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.LocationCircle.serializeBinaryToWriter
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.LocationUpdate.serializeBinaryToWriter
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getNationality();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional LocationCircle searchRadius = 1;
 * @return {?proto.apibuffers.LocationCircle}
 */
proto.apibuffers.UserSearchRequest.prototype.getSearchradius = function() {
  return /** @type{?proto.apibuffers.LocationCircle} */ (
    jspb.Message.getWrapperField(this, common_pb.LocationCircle, 1));
};


/** @param {?proto.apibuffers.LocationCircle|undefined} value */
proto.apibuffers.UserSearchRequest.prototype.setSearchradius = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserSearchRequest.prototype.clearSearchradius = function() {
  this.setSearchradius(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserSearchRequest.prototype.hasSearchradius = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LocationUpdate location = 2;
 * @return {?proto.apibuffers.LocationUpdate}
 */
proto.apibuffers.UserSearchRequest.prototype.getLocation = function() {
  return /** @type{?proto.apibuffers.LocationUpdate} */ (
    jspb.Message.getWrapperField(this, common_pb.LocationUpdate, 2));
};


/** @param {?proto.apibuffers.LocationUpdate|undefined} value */
proto.apibuffers.UserSearchRequest.prototype.setLocation = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserSearchRequest.prototype.clearLocation = function() {
  this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserSearchRequest.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.apibuffers.UserSearchRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.UserSearchRequest.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Gender gender = 4;
 * @return {!proto.apibuffers.Gender}
 */
proto.apibuffers.UserSearchRequest.prototype.getGender = function() {
  return /** @type {!proto.apibuffers.Gender} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.apibuffers.Gender} value */
proto.apibuffers.UserSearchRequest.prototype.setGender = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional CountryCode nationality = 5;
 * @return {!proto.apibuffers.CountryCode}
 */
proto.apibuffers.UserSearchRequest.prototype.getNationality = function() {
  return /** @type {!proto.apibuffers.CountryCode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.apibuffers.CountryCode} value */
proto.apibuffers.UserSearchRequest.prototype.setNationality = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && common_pb.ExtendedUserInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserSearchResponse}
 */
proto.apibuffers.UserSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserSearchResponse;
  return proto.apibuffers.UserSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserSearchResponse}
 */
proto.apibuffers.UserSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.ExtendedUserInfo;
      reader.readMessage(value,common_pb.ExtendedUserInfo.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.ExtendedUserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExtendedUserInfo user = 1;
 * @return {?proto.apibuffers.ExtendedUserInfo}
 */
proto.apibuffers.UserSearchResponse.prototype.getUser = function() {
  return /** @type{?proto.apibuffers.ExtendedUserInfo} */ (
    jspb.Message.getWrapperField(this, common_pb.ExtendedUserInfo, 1));
};


/** @param {?proto.apibuffers.ExtendedUserInfo|undefined} value */
proto.apibuffers.UserSearchResponse.prototype.setUser = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserSearchResponse.prototype.clearUser = function() {
  this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserSearchResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loadInterests: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    loadGroups: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadUserRequest}
 */
proto.apibuffers.UserLoadUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadUserRequest;
  return proto.apibuffers.UserLoadUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadUserRequest}
 */
proto.apibuffers.UserLoadUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLoadInterests(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLoadGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoadInterests();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLoadGroups();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.UserLoadUserRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadUserRequest.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool load_interests = 2;
 * @return {boolean}
 */
proto.apibuffers.UserLoadUserRequest.prototype.getLoadInterests = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.apibuffers.UserLoadUserRequest.prototype.setLoadInterests = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool load_groups = 3;
 * @return {boolean}
 */
proto.apibuffers.UserLoadUserRequest.prototype.getLoadGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.apibuffers.UserLoadUserRequest.prototype.setLoadGroups = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserPrivacySettings.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserPrivacySettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserPrivacySettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserPrivacySettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserPrivacySettings}
 */
proto.apibuffers.UserPrivacySettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserPrivacySettings;
  return proto.apibuffers.UserPrivacySettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserPrivacySettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserPrivacySettings}
 */
proto.apibuffers.UserPrivacySettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserPrivacySettings.PrivacyType} */ (reader.readEnum());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserPrivacySettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserPrivacySettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserPrivacySettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserPrivacySettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserPrivacySettings.PrivacyType = {
  UNKNOWN: 0,
  OPT_IN: 1,
  OPT_OUT: 2
};

/**
 * optional PrivacyType email = 1;
 * @return {!proto.apibuffers.UserPrivacySettings.PrivacyType}
 */
proto.apibuffers.UserPrivacySettings.prototype.getEmail = function() {
  return /** @type {!proto.apibuffers.UserPrivacySettings.PrivacyType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserPrivacySettings.PrivacyType} value */
proto.apibuffers.UserPrivacySettings.prototype.setEmail = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserLoadUserResponse.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto.apibuffers.User.toObject(includeInstance, f),
    friendStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    followingStats: jspb.Message.getFieldWithDefault(msg, 3, 0),
    interestsList: jspb.Message.toObjectList(msg.getInterestsList(),
    proto.apibuffers.Interest.toObject, includeInstance),
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.apibuffers.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadUserResponse}
 */
proto.apibuffers.UserLoadUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadUserResponse;
  return proto.apibuffers.UserLoadUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadUserResponse}
 */
proto.apibuffers.UserLoadUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.apibuffers.User;
      reader.readMessage(value,proto.apibuffers.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.FriendshipStatus} */ (reader.readEnum());
      msg.setFriendStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.apibuffers.FollowingStatus} */ (reader.readEnum());
      msg.setFollowingStats(value);
      break;
    case 4:
      var value = new proto.apibuffers.Interest;
      reader.readMessage(value,proto.apibuffers.Interest.deserializeBinaryFromReader);
      msg.addInterests(value);
      break;
    case 5:
      var value = new proto.apibuffers.Group;
      reader.readMessage(value,proto.apibuffers.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.apibuffers.User.serializeBinaryToWriter
    );
  }
  f = message.getFriendStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFollowingStats();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getInterestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.apibuffers.Interest.serializeBinaryToWriter
    );
  }
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.apibuffers.Group.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.apibuffers.User}
 */
proto.apibuffers.UserLoadUserResponse.prototype.getUser = function() {
  return /** @type{?proto.apibuffers.User} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.User, 1));
};


/** @param {?proto.apibuffers.User|undefined} value */
proto.apibuffers.UserLoadUserResponse.prototype.setUser = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserLoadUserResponse.prototype.clearUser = function() {
  this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserLoadUserResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FriendshipStatus friend_status = 2;
 * @return {!proto.apibuffers.FriendshipStatus}
 */
proto.apibuffers.UserLoadUserResponse.prototype.getFriendStatus = function() {
  return /** @type {!proto.apibuffers.FriendshipStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.FriendshipStatus} value */
proto.apibuffers.UserLoadUserResponse.prototype.setFriendStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional FollowingStatus following_stats = 3;
 * @return {!proto.apibuffers.FollowingStatus}
 */
proto.apibuffers.UserLoadUserResponse.prototype.getFollowingStats = function() {
  return /** @type {!proto.apibuffers.FollowingStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.apibuffers.FollowingStatus} value */
proto.apibuffers.UserLoadUserResponse.prototype.setFollowingStats = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated Interest interests = 4;
 * @return {!Array<!proto.apibuffers.Interest>}
 */
proto.apibuffers.UserLoadUserResponse.prototype.getInterestsList = function() {
  return /** @type{!Array<!proto.apibuffers.Interest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.Interest, 4));
};


/** @param {!Array<!proto.apibuffers.Interest>} value */
proto.apibuffers.UserLoadUserResponse.prototype.setInterestsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.apibuffers.Interest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.Interest}
 */
proto.apibuffers.UserLoadUserResponse.prototype.addInterests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.apibuffers.Interest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadUserResponse.prototype.clearInterestsList = function() {
  this.setInterestsList([]);
};


/**
 * repeated Group groups = 5;
 * @return {!Array<!proto.apibuffers.Group>}
 */
proto.apibuffers.UserLoadUserResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.apibuffers.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.Group, 5));
};


/** @param {!Array<!proto.apibuffers.Group>} value */
proto.apibuffers.UserLoadUserResponse.prototype.setGroupsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.apibuffers.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.Group}
 */
proto.apibuffers.UserLoadUserResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.apibuffers.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadUserResponse.prototype.clearGroupsList = function() {
  this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadExternalImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadExternalImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadExternalImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadExternalImagesRequest}
 */
proto.apibuffers.UserLoadExternalImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadExternalImagesRequest;
  return proto.apibuffers.UserLoadExternalImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadExternalImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadExternalImagesRequest}
 */
proto.apibuffers.UserLoadExternalImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.UserLoadExternalImagesRequest.ImageType} */ (reader.readEnum());
      msg.setImageType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadExternalImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadExternalImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadExternalImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserLoadExternalImagesRequest.ImageType = {
  UNKNOWN: 0,
  INSTAGRAM: 1
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ImageType image_type = 2;
 * @return {!proto.apibuffers.UserLoadExternalImagesRequest.ImageType}
 */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.getImageType = function() {
  return /** @type {!proto.apibuffers.UserLoadExternalImagesRequest.ImageType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.UserLoadExternalImagesRequest.ImageType} value */
proto.apibuffers.UserLoadExternalImagesRequest.prototype.setImageType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.ExternalImage.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.ExternalImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.ExternalImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.ExternalImage.toObject = function(includeInstance, msg) {
  var f, obj = {
    image: (f = msg.getImage()) && common_pb.Image.toObject(includeInstance, f),
    externalUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.ExternalImage}
 */
proto.apibuffers.ExternalImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.ExternalImage;
  return proto.apibuffers.ExternalImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.ExternalImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.ExternalImage}
 */
proto.apibuffers.ExternalImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Image;
      reader.readMessage(value,common_pb.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.ExternalImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.ExternalImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.ExternalImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.ExternalImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getExternalUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Image image = 1;
 * @return {?proto.apibuffers.Image}
 */
proto.apibuffers.ExternalImage.prototype.getImage = function() {
  return /** @type{?proto.apibuffers.Image} */ (
    jspb.Message.getWrapperField(this, common_pb.Image, 1));
};


/** @param {?proto.apibuffers.Image|undefined} value */
proto.apibuffers.ExternalImage.prototype.setImage = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.ExternalImage.prototype.clearImage = function() {
  this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.ExternalImage.prototype.hasImage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string external_url = 2;
 * @return {string}
 */
proto.apibuffers.ExternalImage.prototype.getExternalUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.ExternalImage.prototype.setExternalUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserLoadFacebookFriendsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserLoadFacebookFriendsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    common_pb.BasicUserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserLoadFacebookFriendsResponse}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserLoadFacebookFriendsResponse;
  return proto.apibuffers.UserLoadFacebookFriendsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserLoadFacebookFriendsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserLoadFacebookFriendsResponse}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.BasicUserInfo;
      reader.readMessage(value,common_pb.BasicUserInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserLoadFacebookFriendsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserLoadFacebookFriendsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_pb.BasicUserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BasicUserInfo users = 1;
 * @return {!Array<!proto.apibuffers.BasicUserInfo>}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.apibuffers.BasicUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.BasicUserInfo, 1));
};


/** @param {!Array<!proto.apibuffers.BasicUserInfo>} value */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.setUsersList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.apibuffers.BasicUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.BasicUserInfo}
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.apibuffers.BasicUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserLoadFacebookFriendsResponse.prototype.clearUsersList = function() {
  this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dateOfBirth: (f = msg.getDateOfBirth()) && common_pb.Date.toObject(includeInstance, f),
    bio: jspb.Message.getFieldWithDefault(msg, 5, ""),
    nationality: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sexualPreference: jspb.Message.getFieldWithDefault(msg, 7, 0),
    password: jspb.Message.getFieldWithDefault(msg, 8, ""),
    homeLocation: (f = msg.getHomeLocation()) && common_pb.LocationUpdate.toObject(includeInstance, f),
    privacySettings: (f = msg.getPrivacySettings()) && proto.apibuffers.UserPrivacySettings.toObject(includeInstance, f),
    preferredCurrency: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserUpdateRequest}
 */
proto.apibuffers.UserUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserUpdateRequest;
  return proto.apibuffers.UserUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserUpdateRequest}
 */
proto.apibuffers.UserUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {!proto.apibuffers.Gender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 4:
      var value = new common_pb.Date;
      reader.readMessage(value,common_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfBirth(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBio(value);
      break;
    case 6:
      var value = /** @type {!proto.apibuffers.CountryCode} */ (reader.readEnum());
      msg.setNationality(value);
      break;
    case 7:
      var value = /** @type {!proto.apibuffers.SexualPreference} */ (reader.readEnum());
      msg.setSexualPreference(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 9:
      var value = new common_pb.LocationUpdate;
      reader.readMessage(value,common_pb.LocationUpdate.deserializeBinaryFromReader);
      msg.setHomeLocation(value);
      break;
    case 10:
      var value = new proto.apibuffers.UserPrivacySettings;
      reader.readMessage(value,proto.apibuffers.UserPrivacySettings.deserializeBinaryFromReader);
      msg.setPrivacySettings(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreferredCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDateOfBirth();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getBio();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNationality();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSexualPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHomeLocation();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.LocationUpdate.serializeBinaryToWriter
    );
  }
  f = message.getPrivacySettings();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.apibuffers.UserPrivacySettings.serializeBinaryToWriter
    );
  }
  f = message.getPreferredCurrency();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.apibuffers.UserUpdateRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateRequest.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.apibuffers.UserUpdateRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateRequest.prototype.setUserName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Gender gender = 3;
 * @return {!proto.apibuffers.Gender}
 */
proto.apibuffers.UserUpdateRequest.prototype.getGender = function() {
  return /** @type {!proto.apibuffers.Gender} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.apibuffers.Gender} value */
proto.apibuffers.UserUpdateRequest.prototype.setGender = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Date date_of_birth = 4;
 * @return {?proto.apibuffers.Date}
 */
proto.apibuffers.UserUpdateRequest.prototype.getDateOfBirth = function() {
  return /** @type{?proto.apibuffers.Date} */ (
    jspb.Message.getWrapperField(this, common_pb.Date, 4));
};


/** @param {?proto.apibuffers.Date|undefined} value */
proto.apibuffers.UserUpdateRequest.prototype.setDateOfBirth = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateRequest.prototype.clearDateOfBirth = function() {
  this.setDateOfBirth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateRequest.prototype.hasDateOfBirth = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string bio = 5;
 * @return {string}
 */
proto.apibuffers.UserUpdateRequest.prototype.getBio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateRequest.prototype.setBio = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CountryCode nationality = 6;
 * @return {!proto.apibuffers.CountryCode}
 */
proto.apibuffers.UserUpdateRequest.prototype.getNationality = function() {
  return /** @type {!proto.apibuffers.CountryCode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.apibuffers.CountryCode} value */
proto.apibuffers.UserUpdateRequest.prototype.setNationality = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional SexualPreference sexual_preference = 7;
 * @return {!proto.apibuffers.SexualPreference}
 */
proto.apibuffers.UserUpdateRequest.prototype.getSexualPreference = function() {
  return /** @type {!proto.apibuffers.SexualPreference} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.apibuffers.SexualPreference} value */
proto.apibuffers.UserUpdateRequest.prototype.setSexualPreference = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string password = 8;
 * @return {string}
 */
proto.apibuffers.UserUpdateRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateRequest.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional LocationUpdate home_location = 9;
 * @return {?proto.apibuffers.LocationUpdate}
 */
proto.apibuffers.UserUpdateRequest.prototype.getHomeLocation = function() {
  return /** @type{?proto.apibuffers.LocationUpdate} */ (
    jspb.Message.getWrapperField(this, common_pb.LocationUpdate, 9));
};


/** @param {?proto.apibuffers.LocationUpdate|undefined} value */
proto.apibuffers.UserUpdateRequest.prototype.setHomeLocation = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateRequest.prototype.clearHomeLocation = function() {
  this.setHomeLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateRequest.prototype.hasHomeLocation = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional UserPrivacySettings privacy_settings = 10;
 * @return {?proto.apibuffers.UserPrivacySettings}
 */
proto.apibuffers.UserUpdateRequest.prototype.getPrivacySettings = function() {
  return /** @type{?proto.apibuffers.UserPrivacySettings} */ (
    jspb.Message.getWrapperField(this, proto.apibuffers.UserPrivacySettings, 10));
};


/** @param {?proto.apibuffers.UserPrivacySettings|undefined} value */
proto.apibuffers.UserUpdateRequest.prototype.setPrivacySettings = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateRequest.prototype.clearPrivacySettings = function() {
  this.setPrivacySettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateRequest.prototype.hasPrivacySettings = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string preferred_currency = 11;
 * @return {string}
 */
proto.apibuffers.UserUpdateRequest.prototype.getPreferredCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateRequest.prototype.setPreferredCurrency = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    responseStatus: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserUpdateResponse}
 */
proto.apibuffers.UserUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserUpdateResponse;
  return proto.apibuffers.UserUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserUpdateResponse}
 */
proto.apibuffers.UserUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserUpdateResponse.UpdateUserStatus} */ (reader.readEnum());
      msg.setResponseStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponseStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserUpdateResponse.UpdateUserStatus = {
  USER_UPDATED: 0,
  ERROR_EMAIL_ALREADY_EXISTS: 1,
  ERROR_INVALID_USERNAME: 2,
  ERROR_INVALID_PASSWORD: 3,
  ERROR_INVALID_EMAIL: 4,
  ERROR_INVALID_CURRENCY: 5
};

/**
 * optional UpdateUserStatus response_status = 1;
 * @return {!proto.apibuffers.UserUpdateResponse.UpdateUserStatus}
 */
proto.apibuffers.UserUpdateResponse.prototype.getResponseStatus = function() {
  return /** @type {!proto.apibuffers.UserUpdateResponse.UpdateUserStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserUpdateResponse.UpdateUserStatus} value */
proto.apibuffers.UserUpdateResponse.prototype.setResponseStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserUpdateLocationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserUpdateLocationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateLocationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    latLng: (f = msg.getLatLng()) && common_pb.LatLong.toObject(includeInstance, f),
    accuracy: (f = msg.getAccuracy()) && common_pb.Distance.toObject(includeInstance, f),
    fenceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fenceTriggerType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    returnFences: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserUpdateLocationRequest}
 */
proto.apibuffers.UserUpdateLocationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserUpdateLocationRequest;
  return proto.apibuffers.UserUpdateLocationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserUpdateLocationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserUpdateLocationRequest}
 */
proto.apibuffers.UserUpdateLocationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.LatLong;
      reader.readMessage(value,common_pb.LatLong.deserializeBinaryFromReader);
      msg.setLatLng(value);
      break;
    case 2:
      var value = new common_pb.Distance;
      reader.readMessage(value,common_pb.Distance.deserializeBinaryFromReader);
      msg.setAccuracy(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFenceId(value);
      break;
    case 4:
      var value = /** @type {!proto.apibuffers.GeoFenceEventType} */ (reader.readEnum());
      msg.setFenceTriggerType(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 6:
      var value = /** @type {!proto.apibuffers.UserUpdateLocationRequest.UpdateType} */ (reader.readEnum());
      msg.setUpdateType(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReturnFences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserUpdateLocationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserUpdateLocationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateLocationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatLng();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.LatLong.serializeBinaryToWriter
    );
  }
  f = message.getAccuracy();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Distance.serializeBinaryToWriter
    );
  }
  f = message.getFenceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFenceTriggerType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getReturnFences();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserUpdateLocationRequest.UpdateType = {
  NONE: 0,
  FOREGROUND: 1,
  BACKGROUND: 2
};

/**
 * optional LatLong lat_lng = 1;
 * @return {?proto.apibuffers.LatLong}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getLatLng = function() {
  return /** @type{?proto.apibuffers.LatLong} */ (
    jspb.Message.getWrapperField(this, common_pb.LatLong, 1));
};


/** @param {?proto.apibuffers.LatLong|undefined} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setLatLng = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.clearLatLng = function() {
  this.setLatLng(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.hasLatLng = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Distance accuracy = 2;
 * @return {?proto.apibuffers.Distance}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getAccuracy = function() {
  return /** @type{?proto.apibuffers.Distance} */ (
    jspb.Message.getWrapperField(this, common_pb.Distance, 2));
};


/** @param {?proto.apibuffers.Distance|undefined} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setAccuracy = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.clearAccuracy = function() {
  this.setAccuracy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.hasAccuracy = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string fence_id = 3;
 * @return {string}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getFenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setFenceId = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional GeoFenceEventType fence_trigger_type = 4;
 * @return {!proto.apibuffers.GeoFenceEventType}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getFenceTriggerType = function() {
  return /** @type {!proto.apibuffers.GeoFenceEventType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.apibuffers.GeoFenceEventType} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setFenceTriggerType = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setTime = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.clearTime = function() {
  this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.hasTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional UpdateType update_type = 6;
 * @return {!proto.apibuffers.UserUpdateLocationRequest.UpdateType}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getUpdateType = function() {
  return /** @type {!proto.apibuffers.UserUpdateLocationRequest.UpdateType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.apibuffers.UserUpdateLocationRequest.UpdateType} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setUpdateType = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional bool return_fences = 7;
 * @return {boolean}
 */
proto.apibuffers.UserUpdateLocationRequest.prototype.getReturnFences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.apibuffers.UserUpdateLocationRequest.prototype.setReturnFences = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.GeoFence.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.GeoFence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.GeoFence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.GeoFence.toObject = function(includeInstance, msg) {
  var f, obj = {
    fenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    location: (f = msg.getLocation()) && common_pb.LocationCircle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.GeoFence}
 */
proto.apibuffers.GeoFence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.GeoFence;
  return proto.apibuffers.GeoFence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.GeoFence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.GeoFence}
 */
proto.apibuffers.GeoFence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFenceId(value);
      break;
    case 3:
      var value = new common_pb.LocationCircle;
      reader.readMessage(value,common_pb.LocationCircle.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.GeoFence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.GeoFence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.GeoFence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.GeoFence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.LocationCircle.serializeBinaryToWriter
    );
  }
};


/**
 * optional string fence_id = 1;
 * @return {string}
 */
proto.apibuffers.GeoFence.prototype.getFenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.GeoFence.prototype.setFenceId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LocationCircle location = 3;
 * @return {?proto.apibuffers.LocationCircle}
 */
proto.apibuffers.GeoFence.prototype.getLocation = function() {
  return /** @type{?proto.apibuffers.LocationCircle} */ (
    jspb.Message.getWrapperField(this, common_pb.LocationCircle, 3));
};


/** @param {?proto.apibuffers.LocationCircle|undefined} value */
proto.apibuffers.GeoFence.prototype.setLocation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.apibuffers.GeoFence.prototype.clearLocation = function() {
  this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.apibuffers.GeoFence.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserUpdateLocationResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserUpdateLocationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserUpdateLocationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateLocationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateGeoFences: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    toMonitorList: jspb.Message.toObjectList(msg.getToMonitorList(),
    proto.apibuffers.GeoFence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserUpdateLocationResponse}
 */
proto.apibuffers.UserUpdateLocationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserUpdateLocationResponse;
  return proto.apibuffers.UserUpdateLocationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserUpdateLocationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserUpdateLocationResponse}
 */
proto.apibuffers.UserUpdateLocationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdateGeoFences(value);
      break;
    case 2:
      var value = new proto.apibuffers.GeoFence;
      reader.readMessage(value,proto.apibuffers.GeoFence.deserializeBinaryFromReader);
      msg.addToMonitor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserUpdateLocationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserUpdateLocationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateLocationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateGeoFences();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getToMonitorList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.apibuffers.GeoFence.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool update_geo_fences = 1;
 * @return {boolean}
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.getUpdateGeoFences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.apibuffers.UserUpdateLocationResponse.prototype.setUpdateGeoFences = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated GeoFence to_monitor = 2;
 * @return {!Array<!proto.apibuffers.GeoFence>}
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.getToMonitorList = function() {
  return /** @type{!Array<!proto.apibuffers.GeoFence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.apibuffers.GeoFence, 2));
};


/** @param {!Array<!proto.apibuffers.GeoFence>} value */
proto.apibuffers.UserUpdateLocationResponse.prototype.setToMonitorList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.apibuffers.GeoFence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.apibuffers.GeoFence}
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.addToMonitor = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.apibuffers.GeoFence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserUpdateLocationResponse.prototype.clearToMonitorList = function() {
  this.setToMonitorList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserUpdateInterestsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserUpdateInterestsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserUpdateInterestsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateInterestsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    interestIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserUpdateInterestsRequest}
 */
proto.apibuffers.UserUpdateInterestsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserUpdateInterestsRequest;
  return proto.apibuffers.UserUpdateInterestsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserUpdateInterestsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserUpdateInterestsRequest}
 */
proto.apibuffers.UserUpdateInterestsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserUpdateInterestsRequest.Action} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addInterestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserUpdateInterestsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserUpdateInterestsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserUpdateInterestsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInterestIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserUpdateInterestsRequest.Action = {
  ADD: 0,
  DELETE: 1,
  REPLACE: 2
};

/**
 * optional Action action = 1;
 * @return {!proto.apibuffers.UserUpdateInterestsRequest.Action}
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.getAction = function() {
  return /** @type {!proto.apibuffers.UserUpdateInterestsRequest.Action} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserUpdateInterestsRequest.Action} value */
proto.apibuffers.UserUpdateInterestsRequest.prototype.setAction = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string interest_id = 2;
 * @return {!Array<string>}
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.getInterestIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.apibuffers.UserUpdateInterestsRequest.prototype.setInterestIdList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.addInterestId = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserUpdateInterestsRequest.prototype.clearInterestIdList = function() {
  this.setInterestIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserValidateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserValidateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserValidateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserValidateRequest}
 */
proto.apibuffers.UserValidateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserValidateRequest;
  return proto.apibuffers.UserValidateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserValidateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserValidateRequest}
 */
proto.apibuffers.UserValidateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserValidateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserValidateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserValidateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.apibuffers.UserValidateRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserValidateRequest.prototype.setCode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserValidateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserValidateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserValidateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserValidateResponse}
 */
proto.apibuffers.UserValidateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserValidateResponse;
  return proto.apibuffers.UserValidateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserValidateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserValidateResponse}
 */
proto.apibuffers.UserValidateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserValidateResponse.UserValidateResponseStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserValidateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserValidateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserValidateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserValidateResponse.UserValidateResponseStatus = {
  UNKNOWN: 0,
  OK: 1,
  INVALID_CODE: 2,
  PROCESS_NOT_INITIATED: 3
};

/**
 * optional UserValidateResponseStatus status = 1;
 * @return {!proto.apibuffers.UserValidateResponse.UserValidateResponseStatus}
 */
proto.apibuffers.UserValidateResponse.prototype.getStatus = function() {
  return /** @type {!proto.apibuffers.UserValidateResponse.UserValidateResponseStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserValidateResponse.UserValidateResponseStatus} value */
proto.apibuffers.UserValidateResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserValidateSendCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserValidateSendCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserValidateSendCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateSendCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobileNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserValidateSendCodeRequest}
 */
proto.apibuffers.UserValidateSendCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserValidateSendCodeRequest;
  return proto.apibuffers.UserValidateSendCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserValidateSendCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserValidateSendCodeRequest}
 */
proto.apibuffers.UserValidateSendCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserValidateSendCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserValidateSendCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserValidateSendCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateSendCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMobileNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string mobile_number = 1;
 * @return {string}
 */
proto.apibuffers.UserValidateSendCodeRequest.prototype.getMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserValidateSendCodeRequest.prototype.setMobileNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserValidateSendCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserValidateSendCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserValidateSendCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateSendCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserValidateSendCodeResponse}
 */
proto.apibuffers.UserValidateSendCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserValidateSendCodeResponse;
  return proto.apibuffers.UserValidateSendCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserValidateSendCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserValidateSendCodeResponse}
 */
proto.apibuffers.UserValidateSendCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserValidateSendCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserValidateSendCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserValidateSendCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserValidateSendCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus = {
  UNKNOWN: 0,
  OK: 1,
  INVALID_NUMBER: 2,
  NUMBER_ALREADY_USED: 3
};

/**
 * optional ValidateResponseStatus status = 1;
 * @return {!proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus}
 */
proto.apibuffers.UserValidateSendCodeResponse.prototype.getStatus = function() {
  return /** @type {!proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserValidateSendCodeResponse.ValidateResponseStatus} value */
proto.apibuffers.UserValidateSendCodeResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserSetInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserSetInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserSetInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSetInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserSetInviteRequest}
 */
proto.apibuffers.UserSetInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserSetInviteRequest;
  return proto.apibuffers.UserSetInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserSetInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserSetInviteRequest}
 */
proto.apibuffers.UserSetInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserSetInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserSetInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserSetInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSetInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_code = 1;
 * @return {string}
 */
proto.apibuffers.UserSetInviteRequest.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserSetInviteRequest.prototype.setInviteCode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserSetInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserSetInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserSetInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSetInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserSetInviteResponse}
 */
proto.apibuffers.UserSetInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserSetInviteResponse;
  return proto.apibuffers.UserSetInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserSetInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserSetInviteResponse}
 */
proto.apibuffers.UserSetInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserSetInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserSetInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserSetInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserSetInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus = {
  UNKNOWN: 0,
  OK: 1,
  INVALID_CODE: 2,
  ALREADY_INVITED: 3
};

/**
 * optional UserSetInviteResponseStatus status = 1;
 * @return {!proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus}
 */
proto.apibuffers.UserSetInviteResponse.prototype.getStatus = function() {
  return /** @type {!proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserSetInviteResponse.UserSetInviteResponseStatus} value */
proto.apibuffers.UserSetInviteResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserFollowRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserFollowRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserFollowRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    followType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserFollowRequest}
 */
proto.apibuffers.UserFollowRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserFollowRequest;
  return proto.apibuffers.UserFollowRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserFollowRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserFollowRequest}
 */
proto.apibuffers.UserFollowRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.FollowType} */ (reader.readEnum());
      msg.setFollowType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserFollowRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserFollowRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserFollowRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFollowType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.apibuffers.UserFollowRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserFollowRequest.prototype.setUserId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FollowType follow_type = 2;
 * @return {!proto.apibuffers.FollowType}
 */
proto.apibuffers.UserFollowRequest.prototype.getFollowType = function() {
  return /** @type {!proto.apibuffers.FollowType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.FollowType} value */
proto.apibuffers.UserFollowRequest.prototype.setFollowType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserFollowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserFollowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserFollowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserFollowsResponse}
 */
proto.apibuffers.UserFollowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserFollowsResponse;
  return proto.apibuffers.UserFollowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserFollowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserFollowsResponse}
 */
proto.apibuffers.UserFollowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserFollowsResponse.UserFollowStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserFollowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserFollowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserFollowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserFollowsResponse.UserFollowStatus = {
  OK: 0
};

/**
 * optional UserFollowStatus status = 1;
 * @return {!proto.apibuffers.UserFollowsResponse.UserFollowStatus}
 */
proto.apibuffers.UserFollowsResponse.prototype.getStatus = function() {
  return /** @type {!proto.apibuffers.UserFollowsResponse.UserFollowStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserFollowsResponse.UserFollowStatus} value */
proto.apibuffers.UserFollowsResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.apibuffers.UserBatchFollowRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserBatchFollowRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserBatchFollowRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserBatchFollowRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserBatchFollowRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    followType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserBatchFollowRequest}
 */
proto.apibuffers.UserBatchFollowRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserBatchFollowRequest;
  return proto.apibuffers.UserBatchFollowRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserBatchFollowRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserBatchFollowRequest}
 */
proto.apibuffers.UserBatchFollowRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 2:
      var value = /** @type {!proto.apibuffers.FollowType} */ (reader.readEnum());
      msg.setFollowType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserBatchFollowRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserBatchFollowRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserBatchFollowRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserBatchFollowRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getFollowType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */
proto.apibuffers.UserBatchFollowRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.apibuffers.UserBatchFollowRequest.prototype.setUserIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.apibuffers.UserBatchFollowRequest.prototype.addUserIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.apibuffers.UserBatchFollowRequest.prototype.clearUserIdsList = function() {
  this.setUserIdsList([]);
};


/**
 * optional FollowType follow_type = 2;
 * @return {!proto.apibuffers.FollowType}
 */
proto.apibuffers.UserBatchFollowRequest.prototype.getFollowType = function() {
  return /** @type {!proto.apibuffers.FollowType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.apibuffers.FollowType} value */
proto.apibuffers.UserBatchFollowRequest.prototype.setFollowType = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserBatchFollowResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserBatchFollowResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserBatchFollowResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserBatchFollowResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserBatchFollowResponse}
 */
proto.apibuffers.UserBatchFollowResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserBatchFollowResponse;
  return proto.apibuffers.UserBatchFollowResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserBatchFollowResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserBatchFollowResponse}
 */
proto.apibuffers.UserBatchFollowResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserBatchFollowResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserBatchFollowResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserBatchFollowResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserBatchFollowResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus = {
  UNKNOWN: 0,
  OK: 1,
  ERROR: 2
};

/**
 * optional UserBatchFollowStatus status = 1;
 * @return {!proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus}
 */
proto.apibuffers.UserBatchFollowResponse.prototype.getStatus = function() {
  return /** @type {!proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.UserBatchFollowResponse.UserBatchFollowStatus} value */
proto.apibuffers.UserBatchFollowResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.UserFollowRelationship.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.UserFollowRelationship.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.UserFollowRelationship} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowRelationship.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.UserFollowRelationship}
 */
proto.apibuffers.UserFollowRelationship.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.UserFollowRelationship;
  return proto.apibuffers.UserFollowRelationship.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.UserFollowRelationship} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.UserFollowRelationship}
 */
proto.apibuffers.UserFollowRelationship.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.UserFollowRelationship.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.UserFollowRelationship.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.UserFollowRelationship} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.UserFollowRelationship.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.apibuffers.UserFollowRelationship.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.apibuffers.UserFollowRelationship.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.apibuffers.SessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.apibuffers.SessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.apibuffers.SessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.SessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.apibuffers.SessionRequest}
 */
proto.apibuffers.SessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.apibuffers.SessionRequest;
  return proto.apibuffers.SessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.apibuffers.SessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.apibuffers.SessionRequest}
 */
proto.apibuffers.SessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.apibuffers.SessionRequest.SessionRequestType} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.apibuffers.SessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.apibuffers.SessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.apibuffers.SessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.apibuffers.SessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.apibuffers.SessionRequest.SessionRequestType = {
  START: 0,
  END: 1
};

/**
 * optional SessionRequestType session_Type = 1;
 * @return {!proto.apibuffers.SessionRequest.SessionRequestType}
 */
proto.apibuffers.SessionRequest.prototype.getSessionType = function() {
  return /** @type {!proto.apibuffers.SessionRequest.SessionRequestType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.apibuffers.SessionRequest.SessionRequestType} value */
proto.apibuffers.SessionRequest.prototype.setSessionType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.apibuffers.Gender = {
  UNKNOWN_GENDER: 0,
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
  WITHHELD_GENDER: 4
};

/**
 * @enum {number}
 */
proto.apibuffers.SexualPreference = {
  UNKNOWN_SEXUAL_PREFERENCE: 0,
  STRIGHT: 1,
  GAY: 2,
  BI_SEXUAL: 3,
  WITHHELD_SEXUAL_PREFERENCE: 4
};

/**
 * @enum {number}
 */
proto.apibuffers.FollowingStatus = {
  NOT_FOLLOWING: 0,
  FOLLOWING: 1,
  BLOCKED_FOLLOWING: 2
};

/**
 * @enum {number}
 */
proto.apibuffers.UserStatus = {
  GUEST: 0,
  NORMAL: 1,
  DEACTIVE: 2,
  INCOMPLETE: 4
};

/**
 * @enum {number}
 */
proto.apibuffers.LegalRequirements = {
  GDPR: 0
};

/**
 * @enum {number}
 */
proto.apibuffers.GeoFenceEventType = {
  ENTER: 0,
  EXIT: 1
};

/**
 * @enum {number}
 */
proto.apibuffers.FollowType = {
  FOLLOW: 0,
  UNFOLLOW: 1
};

goog.object.extend(exports, proto.apibuffers);
